"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var tema_1 = require("../../tema");
var BoxDaEstrela = function (_a) {
  var sx = _a.sx,
    props = __rest(_a, ["sx"]);
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: __assign({
      display: 'flex',
      whiteSpace: 'nowrap',
      svg: __assign({
        stroke: tema_1.colors.amarelo,
        color: tema_1.colors.amarelo,
        '&.ativo': {
          fill: tema_1.colors.amarelo,
          '&.naoEditavel': {
            fill: tema_1.colors.gray3,
            '&.selecionado': {
              fill: tema_1.colors.amarelo,
              stroke: tema_1.colors.amarelo
            }
          }
        },
        '&.naoEditavel': {
          stroke: tema_1.colors.gray3
        },
        '&.hover': {
          color: tema_1.colors.amarelo,
          fill: tema_1.colors.amarelo,
          stroke: tema_1.colors.amarelo
        }
      }, sx === null || sx === void 0 ? void 0 : sx.svg)
    }, sx)
  }, props));
};
exports.default = BoxDaEstrela;